export default __webpack_public_path__ + "static/media/targa_europe_2019.d4416b97.jpg";